<template>
	<div class="medicine_code" v-if="returnShow">
		<slot name="start"></slot>
		<template v-if="!!goods.attr && !!goods.attr.attr_country_code">
			<el-popover trigger="hover" :visible-arrow="false" placement="bottom-start" popper-class="goods-label-popover">
				<div class="content copy-content">
					<div @click="copy(goods.attr.attr_country_code)">
						<span>复制</span>
					</div>
					<span class="copy-content-text">{{goods.attr.attr_country_code}}</span>
				</div>
				<template slot="reference">
					<el-tag size="mini" type="error" :style="returnCountryStyle">国家码</el-tag>
				</template>
			</el-popover>
		</template>
		<template v-if="goods.is_jc==1">
			<el-tag size="mini" type="error" :style="returnJcStyle">集采</el-tag>
		</template>
		<template v-if="goods.traceability_code==1">
			<el-tag size="mini" type="error" :style="returnTraceabilityStyle">追溯码</el-tag>
		</template>
		<slot name="end"></slot>
    </div>
</template>
<script>

export default {
	name: "goods-code-label",
	props: {
		goods: {
			type: Object,
			required: true,
			default: ''
		}
	},
	data() {
		return {}
	},
	computed: {
		storeToken() {
			return this.$store.state.member.token;
		},
		returnCountryStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.country_code_background_color,colors.country_code_font_color);
			}else{
				return this.getTagStyle('#6DD4C4','#FFFFFF');
			}
		},
		returnJcStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.collect_background_color,colors.collect_font_color);
			}else{
				return this.getTagStyle('#FFAA00','#FFFFFF');
			}
		},
		returnTraceabilityStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.trace_code_background_color,colors.trace_code_font_color);
			}else{
				return this.getTagStyle('#F55E82','#FFFFFF');
			}
		},
		returnShow(){
			let bool1 = (!!this.goods.attr && !!this.goods.attr.attr_country_code);
			let bool2 = (this.goods.is_jc==1);
			let bool3 = (this.goods.traceability_code==1);
			let bool4 = (this.$slots.start || this.$slots.end);
			return bool1 || bool2 || bool3 || bool4;
		}
	},
	methods: {
		copy(content){
            this.$util.copy(content);
            this.$message.success('复制成功');
        },
		getTagStyle(bgColor,fontColor){
			const defaultStyle = 'border:none;display:flex;line-height: 22px;';
			return `background-color: ${bgColor};color: ${fontColor};${defaultStyle}`
		}
	}
}
</script>



<style scoped lang="scss">
.medicine_code{
	display: flex;
	align-items: center;
	gap: 3px;
	flex-wrap: wrap;
}
.code_defalut{
	display: flex;
	align-items: center;
	justify-content: center;
	>span{
		font-weight: 400;
		font-size: 11px;
		line-height: 16px;
	}
}
.code_cc{
	width: 39px;
	height: 16px;
	border-radius: 6px;
	border: 1px solid #6DD4C4;
	>span{
		color: #6DD4C4;
	}
}
.code_cb{
	width: 31px;
	height: 16px;
	border-radius: 6px;
	border: 1px solid #FFAA00;
	>span{
		color: #FFAA00;
	}
}
.code_tc{
	width: 41px;
	height: 16px;
	border-radius: 6px;
	border: 1px solid #F55E82;
	>span{
		color: #F55E82;
	}
}
.goods-label-popover {
    padding: 6px;
    margin-top: 6px !important;
    box-sizing: border-box;
    border: 1px solid #ff547b;
}
.content{
    display: flex;
    flex-direction: column;
    gap: 6px;
    >p:nth-child(1){
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    >div:not(:first-child){
        display: flex;
        flex-direction: column;
        gap: 6px;
        >p:nth-child(1){
            font-size: 12px;
            line-height: 14px;
            color: #ff547b;
        }
        >p:nth-child(2){
            font-size: 12px;
            line-height: 14px;
            color: #787878;
        }
    }
    
}
.copy-content{
    align-items: center;
    flex-direction: row !important;
    >div:nth-child(1){
        padding: 2px;
        box-sizing: border-box;
        border: 1px solid #ff547b;
        border-radius: 4px;
        cursor: pointer;
        flex-shrink: 0;
        >span{
            font-size: 12px;
            line-height: 14px;
            color: #ff547b;
        }
    }
    >.copy-content-text{
        font-size: 12px;
        line-height: 14px;
        color: #333;
    }
}
</style>
